module.exports = __webpack_public_path__ + "735122f3c791690a2fa71c4e1357b23e.png";